export default "__VITE_ASSET__DwD0xwk___"